module.exports = __webpack_public_path__ + "static/media/flower.669e978f.mp4";